export enum EnumClosingCostType {
  flatFee = 'flat_fee',
  percentageOfLoanAmount = 'percentage_of_loan_amount',
  percentageOfPurchasePrice = 'percentage_of_purchase_price',
  prepaidInterest15Days = 'prepaid_interest_15_days',
  propertyTaxes = 'property_taxes',
  homeownersInsurance = 'homeowners_insurance',
}
